import { combineReducers } from 'redux';
import type { AnyAction } from 'redux';
import { chatReducer } from '@packages/shared/core/chat/store';
import { expertsReducer } from '@packages/shared/core/experts/store';
import { userReducer, userUtmTagsReducer, userInteractionReducer } from '@packages/shared/core/user/store/reducer';
import { locationReducer } from '@packages/shared/core/location/store';
import { supportReducer } from '@packages/shared/core/support/store';
import { systemReducer } from './system';

export const HYDRATE_FROM_STORAGE = 'HYDRATE_FROM_STORAGE';

const combinedReducer = combineReducers({
  system: systemReducer,
  user: userReducer,
  userUtmTags: userUtmTagsReducer,
  userInteraction: userInteractionReducer,
  experts: expertsReducer,
  location: locationReducer,
  chat: chatReducer,
  support: supportReducer,
});

export type RootInitialState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: RootInitialState | undefined, action: AnyAction): RootInitialState => {
  if (action.type === HYDRATE_FROM_STORAGE && action.payload) {
    return combinedReducer({ ...state, ...action.payload } as RootInitialState, action);
  }

  return combinedReducer(state, action);
};

export const getRootState = (state: RootInitialState) => state;

export default rootReducer;
